import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-store-2-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold text-background-50">洞洞杂货铺漫画</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              在线免费阅读洞洞杂货铺漫画全集尽在178漫画网，无需付费等待，打开即可沉浸式追漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">分类浏览</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(1, 7).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门漫画</h4>
            <div className="flex flex-col gap-2">
              <Link to="/manga/dongdong-zahuopu" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">洞洞杂货铺</Link>
              <Link to="/manga/yanhuo-shijian" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">烟火人间</Link>
              <Link to="/manga/xingkong-zhiyue" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">星空之约</Link>
              <Link to="/manga/shikong-lieche" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">时空列车</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">品牌介绍</Link>
              <span className="text-sm text-background-500">联系邮箱：contact@178mh.com</span>
              <span className="text-sm text-background-500">客服QQ：800123456</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 洞洞杂货铺漫画 - 178漫画网 版权所有
          </p>
          <p className="text-sm text-background-500">
            本站所有漫画均来自网络，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}